import {
  IMeta,
  IPaymentCard,
  IBusinessAccount,
  IBusiness,
  ISubscriptionInfo,
  ISubscriptionPlanData,
} from 'src/common/interfaces/index.js'
import businessClient from 'src/services/clients/business'

const IPaymentMethodResponse = { meta: IMeta, data: { list: IPaymentCard } }
const IBusinessInfoResponse = { meta: IMeta, data: { list: IBusinessAccount } }
const IBusinessInfoUpdateResponse = { meta: IMeta, data: { update: [IBusiness] } }
const ISubscriptionPlansResponse = { meta: IMeta, data: ISubscriptionPlanData }

export const billing = {
  /**
   * @returns {Promise<IPaymentMethodResponse>}
   */
  getPaymentMethods(signal) {
    return businessClient().post('billing/card/get', { signal })
  },
  /**
   * @returns {{url: string}}
   */
  addPaymentMethod(signal) {
    return businessClient().post('billing/card/add', { signal })
  },
  /**
   * @returns {Promise<IBusinessInfoResponse>}
   */
  getBusinessInfo(signal) {
    return businessClient().post('billing/business/get', { signal })
  },
  /**
   * @param {IBusinessAccount} data
   * @returns {Promise<IBusinessInfoUpdateResponse>}
   */
  updateBusinessInfo(data, signal) {
    return businessClient().post('billing/business/update', { data }, { signal })
  },
  /**
   * @returns {Promise<ISubscriptionInfo>}
   */
  getSubscriptionInfo(signal) {
    return businessClient().post('billing/subscription/info', { signal })
  },
  /**
   * @returns {Promise<ISubscriptionPlansResponse>}
   */
  getSubscriptionPlans(signal) {
    return businessClient().post('billing/subscription/update/info', { signal })
  },
  /**
   * @param {{subscription_id: number; active: boolean}} data
   * @returns {Promise<{}>}
   */
  updateSubscriptionFeature(data, signal) {
    return businessClient().post('billing/subscription/update', { data }, { signal })
  },
  /**
   * @param {{plan_id: number; interval: number}} data
   * @returns {Promise<{}>}
   */
  updateSubscriptionPlan(data, signal) {
    return businessClient().post('billing/subscription/update-apppair-plan', { data }, { signal })
  },
}
